import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
export class LayoutGlobalManagementHeaderVisibilityService {
    constructor() {
        this.customerVisibleSubject = new BehaviorSubject(false);
        this.gyosekiManagementVisibleSubject = new BehaviorSubject(false);
        this.customerVisible$ = this.customerVisibleSubject.asObservable();
        this.gyosekiManagementVisible$ = this.gyosekiManagementVisibleSubject.asObservable();
    }
    toggleGlobalCustomerHeader() {
        const current = this.customerVisibleSubject.getValue();
        this.customerVisibleSubject.next(!current);
        this.gyosekiManagementVisibleSubject.next(false);
    }
    toggleGlobalGyosekiManagementHeader() {
        const current = this.gyosekiManagementVisibleSubject.getValue();
        this.gyosekiManagementVisibleSubject.next(!current);
        this.customerVisibleSubject.next(false);
    }
}
LayoutGlobalManagementHeaderVisibilityService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LayoutGlobalManagementHeaderVisibilityService_Factory() { return new LayoutGlobalManagementHeaderVisibilityService(); }, token: LayoutGlobalManagementHeaderVisibilityService, providedIn: "root" });
